import React from "react";
import Compliances from "./Compliances";

const EXCISE_TYPES = ["Excise"];

export default function Excise() {
  return (
    <Compliances
      moduleTitle="Excise"
      moduleTypes={EXCISE_TYPES}
      hideTypeColumn={true}
      hidePriority={true}
    />
  );
}
